<div class="modal">
  <div class="modal-content" *ngIf="!successModal">
    <div class="modal-title">
      <p class="subtitule-bay-2">
        <span class="icon-Add-Guest"></span>
        Agregar a un invitado a tu visita
      </p>
      <div class="modal-close">
        <button type="button" (click)="close()">&#10799;</button>
      </div>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" autocomplete="off">
        <div class="ggi-input">
          <input
            type="text"
            formControlName="firstName"
            id="firstName"
            ggiJourneyControlValidator
            [submitted]="form.get('firstName')?.touched"
          />
          <label for="firstName">Nombre</label>
        </div>
        <div class="ggi-input">
          <input
            type="text"
            formControlName="lastName"
            id="lastNName"
            ggiJourneyControlValidator
            [submitted]="form.get('lastName')?.touched"
          />
          <label for="lastName">Apellido</label>
        </div>
        <div class="ggi-input">
          <input
            type="email"
            formControlName="email"
            id="email"
            ggiJourneyControlValidator
            [submitted]="form.get('email')?.touched"
          />
          <label for="email">Correo electrónico</label>
        </div>
        <div class="modal-actions-center">
          <button
            type="button"
            class="btn-send btn-filled"
            (click)="sendInvitation()"
          >
            Enviar invitación
            <span class="icon-Send"></span>
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-content" *ngIf="successModal">
    <div class="modal-title">
      <div class="modal-close">
        <button type="button" (click)="close()">&#10799;</button>
      </div>
    </div>
    <div class="modal-body modal-invitation-send">
      <img src="/assets/img/icons/icon-sent@svg.svg" alt="sent" />

      <h4>Hemos enviado un link al correo que ingresaste</h4>
      <button type="button" class="btn-filled" (click)="close()">
        Aceptar
      </button>
      <p class="add-other-guest subtitule-2" (click)="backToForm()">
        <span class="icon-Add-Guest"></span>
        Invitar a alguien más
      </p>
    </div>
  </div>
</div>
